import S3BucketClient from '@/api/s3-bucket.client';
import store from '@/store';
import EsMarcaClient from '@/api/SistemaDKP/sls-marca.client';

export default class S3BucketService {
  constructor() {
    this.client = new S3BucketClient();
    this.clientMarca = new EsMarcaClient();
    this.store = store;
  }

  async upload(fileOrImg, typeFile = 'image' || 'pdf', caminho) {
    if (!file || !(file instanceof File || file instanceof Blob)) {
      throw new Error('Arquivo inválido fornecido para upload');
    }

    const MAX_SIZE = 5 * 1024 * 1024; // 5MB
    if (file.size > MAX_SIZE) {
      throw new Error('Arquivo muito grande. Tamanho máximo permitido: 5MB');
    }

    try {
      const formData = new FormData();
      formData.append('file', fileOrImg);
      formData.append('typeFile', typeFile);
      formData.append('caminho', caminho);
      const data = await this.client.postS3Upload(formData);
      if (!data?.data?.image_url) {
        throw new Error('URL da imagem não retornada pelo servidor');
      }
      return data;
    } catch (error) {
      console.error('Erro no upload:', error);
    }
  }
}
